import { render, staticRenderFns } from "./activity-form-preview.vue?vue&type=template&id=6fae71e3&scoped=true&"
import script from "./activity-form-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-preview.vue?vue&type=style&index=0&id=6fae71e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae71e3",
  null
  
)

component.options.__file = "activity-form-preview.vue"
export default component.exports